module.exports = __webpack_public_path__ + "img/11.ea432d25.png";